"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MenuList = exports.MenuItem = void 0;
var _styles = require("@material-ui/core/styles");
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MenuItem = exports.MenuItem = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(2, 3),
      '& > svg': {
        margin: theme.spacing(0, 1, 0, -0.5)
      }
    }
  };
})(_MenuItem["default"]);
var MenuList = exports.MenuList = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(1, 0)
    }
  };
})(_MenuList["default"]);

/** This component is just a styled version of Material-ui's menu. */
var _default = exports["default"] = (0, _styles.withStyles)(function (theme) {
  return {
    paper: {
      boxShadow: theme.customShadows.small,
      borderRadius: 5
    },
    list: {
      padding: 0
    }
  };
})(_Menu["default"]);